import { RecurlyTransaction, Transactions } from '@videoblocks/subscription-service-client';
import { transactionApi } from './subscriptionServiceConfig';
import { TransactionApiProcessRefundRequest } from '@videoblocks/subscription-service-client/api/transaction-api';
import { isAxiosError } from 'axios';
import { createLogger } from 'logging';

const logger = createLogger('TransactionsApi');

const getHistoricTransactionsByUserId = async (userId: number): Promise<Transactions> => {
    const result = await transactionApi.getHistoricTransactionsByUserId({userId});
    return result.data;
}

const getRecurlyTransactionsByUserId = async (userId: number): Promise<RecurlyTransaction[]> => {
    const result = await transactionApi.getRecurlyTransactionsByUserId({userId});
    return result.data;
}

const processRefund = async (requestParameters: TransactionApiProcessRefundRequest): Promise<any> => {
    try {
        const result = await transactionApi.processRefund(requestParameters);
        return result.data;
    } catch (e: unknown) {
        if (isAxiosError(e)) {
            if (e.response?.status === 400) {
                logger.warn('Error refunding transaction. message: %s', e.message);
                return e.response?.data;
            }
        }
        throw e;
    }
}

export const TransactionsApi = {
    getHistoricTransactionsByUserId,
    getRecurlyTransactionsByUserId,
    processRefund
};